import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

export default function CreateOutcomeCode({ events, serverErrorMsg }) {
  const [state, setState] = useState({ codeName: '' });

  const locale = events.locale;
  const maxNameLength = 50;

  const isInvalid = value => {
    return value.length > maxNameLength;
  };

  const isServerError = () => {
    return serverErrorMsg !== '';
  };

  const showErrorMsg = () => {
    return isInvalid(state.codeName)
      ? locale.getMsg('validationMaxLength', [maxNameLength.toString()])
      : serverErrorMsg;
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '400px' }}>
          <div className="sidePanel-header form-header">
            <div className="sidePanel-header-subtitle">
              <Box display="flex">
                <Box flexGrow={1} py={1}>
                  <Typography variant="subtitle1">{locale.getMsg('createOutcomeCodeHeader')}</Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => events.onClose()}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              </Box>
            </div>
          </div>
          <div className="sidePanel-content content-top-padding">
            <Typography variant="h6" gutterBottom>
              {locale.getMsg('outComeCodeName')}
            </Typography>
            <TextField
              required
              fullWidth
              rows={1}
              value={state.codeName}
              helperText={showErrorMsg()}
              error={isInvalid(state.codeName) || isServerError()}
              onChange={e => setState({ ...state, codeName: e.target.value })}
            />
          </div>

          <div className="sidePanel-footer">
            <div className="sidePanel-buttons">
              <div className="sidePanel-BackButton">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => events.onClose()}
                  style={{ marginRight: '10px' }}
                >
                  {locale.getMsg('back')}
                </Button>
              </div>
              <div className="sidePanel-saveButton">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!state.codeName || isInvalid(state.codeName)}
                  onClick={() => events.createOutcomeCode(state.codeName)}
                >
                  {locale.getMsg('create')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    </section>
  );
}
